import gql from 'graphql-tag';

export const surveyOpportunityFragment = gql`{
  id
}`
